(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2957"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2957"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jmFFy", function(module, exports) {

$parcel$export(module.exports, "initFAQ", function () { return $84c9ae54eae311c3$export$91c34452fd189695; });

var $koLG2 = parcelRequire("koLG2");
const $84c9ae54eae311c3$var$acordeonFeature = ()=>{
    const $faqContainer = document.querySelector('[data-js="faq"]');
    if (!$faqContainer) return;
    (0, $koLG2.initDetailsAccordion)($faqContainer, '[data-js="faq-item"]');
};
const $84c9ae54eae311c3$export$91c34452fd189695 = ()=>{
    $84c9ae54eae311c3$var$acordeonFeature();
};

});
parcelRegister("koLG2", function(module, exports) {

$parcel$export(module.exports, "initDetailsAccordion", function () { return $b12cef79cc123d2b$export$45b65a693d4d6ae1; });
/**
 * Makes a group of <details> elements inside a container behave like an accordion:
 * opening one automatically closes any other currently open element matching the selector.
 *
 * Uses a single delegated listener on the container instead of one per <details>,
 * so it also picks up elements added to the DOM later.
 *
 * Note: the native `toggle` event does not bubble, so the listener is registered
 * in the capture phase — capturing still fires for non-bubbling events.
 */ const $b12cef79cc123d2b$export$45b65a693d4d6ae1 = ($container, detailsSelector)=>{
    const isMatchingOpenDetails = ($target)=>$target instanceof HTMLDetailsElement && $target.matches(detailsSelector) && $target.open;
    $container.addEventListener('toggle', (event)=>{
        const $toggledDetails = event.target;
        if (!isMatchingOpenDetails($toggledDetails)) return;
        const $allDetails = $container.querySelectorAll(`${detailsSelector}[open]`);
        $allDetails.forEach(($details)=>{
            if ($details !== $toggledDetails) $details.removeAttribute('open');
        });
    }, true);
};

});


parcelRegister("d8tQ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90c4571c3a376e78$export$2e2bcd8739ae039; });

var $knCXs = parcelRequire("knCXs");

var $9KW2j = parcelRequire("9KW2j");
/**
 * Populates dialog image element with QR code data from the opener element's data attributes.
 *
 * @param dialogImage - The image element inside the dialog to populate
 * @param opener - The element that triggered the dialog
 *
 * @example
 * Opener element should have these data attributes:
 * <button data-qr-opener data-qr-src="image.png" data-qr-alt="QR Code" data-qr-width="200" data-qr-height="200">Open QR</button>
 */ const $90c4571c3a376e78$var$setDialogImageFromOpener = (dialogImage, opener)=>{
    const qrSrc = opener.getAttribute('data-qr-src') ?? '';
    const qrAlt = opener.getAttribute('data-qr-alt') ?? '';
    const qrWidth = opener.getAttribute('data-qr-width');
    const qrHeight = opener.getAttribute('data-qr-height');
    if (!qrSrc) return;
    dialogImage.src = qrSrc;
    dialogImage.alt = qrAlt;
    if (qrWidth) dialogImage.width = Number(qrWidth);
    if (qrHeight) dialogImage.height = Number(qrHeight);
};
/**
 * Handles a click on a QR opener element.
 * On desktop: shows the QR modal populated with the opener's QR image.
 * On mobile/touch: redirects to the app download link from `data-app-download-link`.
 *
 * @param opener - The clicked element with `data-qr-*` and `data-app-download-link` attributes
 * @param dialog - The global QR dialog element
 * @param dialogImage - The image element inside the dialog
 */ const $90c4571c3a376e78$var$handleOpenerClick = (opener, dialog, dialogImage)=>{
    if ((0, $9KW2j.isMobileDevice)()) {
        const link = opener.getAttribute('data-app-download-link');
        if (link) window.location.href = link;
        return;
    }
    $90c4571c3a376e78$var$setDialogImageFromOpener(dialogImage, opener);
    if (typeof HTMLDialogElement === 'function') dialog.showModal();
    else dialog.removeAttribute('hidden');
};
/**
 * Initializes the global QR code popup.
 * Finds all `[data-qr-opener]` elements and attaches click handlers.
 * Requires `[data-qr-dialog-global]` and `[data-qr-dialog-image]` to be present in the DOM.
 */ const $90c4571c3a376e78$var$initQrPopup = ()=>{
    const dialog = document.querySelector('[data-qr-dialog-global]');
    const openers = Array.from(document.querySelectorAll('[data-qr-opener]'));
    if (!dialog || !openers.length) {
        console.error('QR popup initialization failed:', {
            dialogFound: Boolean(dialog),
            openerCount: openers.length
        });
        return;
    }
    const dialogImage = dialog.querySelector('[data-qr-dialog-image]');
    if (!dialogImage) {
        console.error('QR popup initialization failed: dialog image not found.');
        return;
    }
    openers.forEach((opener)=>{
        opener.addEventListener('click', ()=>$90c4571c3a376e78$var$handleOpenerClick(opener, dialog, dialogImage));
    });
    (0, $knCXs.modalHandle)(dialog);
};
var $90c4571c3a376e78$export$2e2bcd8739ae039 = $90c4571c3a376e78$var$initQrPopup;

});
parcelRegister("knCXs", function(module, exports) {

$parcel$export(module.exports, "modalHandle", function () { return $9258b8f367a9c85a$export$eaa6d74f8f42be11; });
/**
 * Sets up a dialog element to function as a tooltip that appears when hovering over a specified element.
 *
 * This function:
 * - Handles browser compatibility for the HTML Dialog element
 * - If the browser supports HTMLDialogElement, it uses the native show/close methods
 * - If not supported, it falls back to using the hidden attribute
 * - Sets the dialog parent's position to 'relative'
 * - Adds a 'tooltip' class to the dialog element
 *
 * @param dialog - The HTML dialog element to be displayed as a tooltip
 * @param dialogOpener - The element that triggers the dialog when hovered over
 *
 * @example
 * ```typescript
 * const dialog = document.querySelector<HTMLDialogElement>('#my-tooltip');
 * const opener = document.querySelector<HTMLElement>('#tooltip-opener');
 *
 * if (dialog && opener) {
 *   dialogHandle(dialog, opener);
 * }
 * ```
 */ const $9258b8f367a9c85a$export$f4caa643aa66c9b9 = (dialog, dialogOpener)=>{
    dialog.parentElement.style.position = 'relative';
    dialog.classList.add('tooltip');
    // check if dialog tag is supported
    if (typeof HTMLDialogElement === 'function') {
        dialog.removeAttribute('hidden');
        dialogOpener.addEventListener('mouseenter', ()=>dialog.show());
        dialogOpener.addEventListener('mouseout', ()=>dialog.close());
    } else {
        dialog.setAttribute('hidden', '');
        dialogOpener.addEventListener('mouseenter', ()=>dialog.removeAttribute('hidden'));
        dialogOpener.addEventListener('mouseout', ()=>dialog.setAttribute('hidden', ''));
    }
};
const $9258b8f367a9c85a$export$eaa6d74f8f42be11 = (modal, modalOpeners)=>{
    const closeBtn = modal.querySelector('[data-modal-close]');
    // Handle multiple openers or single opener
    const attachOpenEvent = (opener, action)=>{
        opener.addEventListener('click', action);
    };
    const setupOpeners = (action)=>{
        if (!modalOpeners) return;
        if (Array.isArray(modalOpeners)) modalOpeners.forEach((opener)=>attachOpenEvent(opener, action));
        else attachOpenEvent(modalOpeners, action);
    };
    // check if dialog tag is supported
    if (typeof HTMLDialogElement === 'function') {
        modal.removeAttribute('hidden');
        setupOpeners(()=>modal.showModal());
        modal.addEventListener('click', (e)=>{
            if (e.detail === 0) return; // ignore focus events
            const dialogDimensions = modal.getBoundingClientRect();
            if (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom) modal.close();
        });
        if (closeBtn) closeBtn.addEventListener('click', ()=>modal.close());
    } else {
        modal.setAttribute('hidden', '');
        setupOpeners(()=>modal.removeAttribute('hidden'));
        modal.addEventListener('click', (e)=>{
            const dialogDimensions = modal.getBoundingClientRect();
            if (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom) modal.setAttribute('hidden', '');
        });
        if (closeBtn) closeBtn.addEventListener('click', ()=>modal.setAttribute('hidden', ''));
    }
};

});

parcelRegister("9KW2j", function(module, exports) {

$parcel$export(module.exports, "isAndroid", function () { return $9b42097cc816bb4d$export$a11b0059900ceec8; });
$parcel$export(module.exports, "isMobileDevice", function () { return $9b42097cc816bb4d$export$44f917bf91becd01; });
$parcel$export(module.exports, "isAppInstalled", function () { return $9b42097cc816bb4d$export$4fe30fcd38d81a35; });
const $9b42097cc816bb4d$export$a11b0059900ceec8 = ()=>{
    return /Android/i.test(navigator.userAgent);
};
const $9b42097cc816bb4d$export$44f917bf91becd01 = ()=>{
    const userAgent = navigator.userAgent.toLowerCase();
    const isStandardMobile = /android|iphone|ipad|ipod/.test(userAgent);
    const isNewIPad = userAgent.includes('mac') && navigator.maxTouchPoints > 0;
    return isStandardMobile || isNewIPad;
};
const $9b42097cc816bb4d$export$4fe30fcd38d81a35 = async (appId)=>{
    if (!navigator.getInstalledRelatedApps) return false;
    try {
        const relatedApps = await navigator.getInstalledRelatedApps();
        return relatedApps.some((app)=>app.id === appId);
    } catch (error) {
        console.error(error);
        return false;
    }
};

});


const $a7dc2840eccdb24c$var$startAnimationOnSteps = (manual)=>{
    const steps = manual.querySelectorAll('li');
    const delay = 100;
    steps.forEach((step, index)=>{
        setTimeout(()=>{
            step.classList.add('is-visible');
        }, index * delay);
    });
};
const $a7dc2840eccdb24c$var$resetAnimationOnSteps = (manual)=>{
    const steps = manual.querySelectorAll('li');
    steps.forEach((step)=>{
        step.classList.remove('is-visible');
    });
};
const $a7dc2840eccdb24c$var$handleProductSwitching = ()=>{
    const orderManualSwitcher = document.querySelector('[data-product-switcher]');
    const radioButtons = orderManualSwitcher?.querySelectorAll('input[name="card-order-products"]');
    const orderManuals = document.querySelectorAll('[data-app-order]');
    if (!orderManualSwitcher || !radioButtons || orderManuals.length === 0) {
        console.error('Order manual switcher or radio buttons or manuals not found');
        return;
    }
    radioButtons.forEach((radio)=>{
        radio.addEventListener('change', (event)=>{
            orderManuals.forEach((manual)=>{
                manual.setAttribute('hidden', 'true');
                $a7dc2840eccdb24c$var$resetAnimationOnSteps(manual);
            });
            const targetManualId = event.target.value;
            const targetManual = document.querySelector(`#${targetManualId}`);
            if (targetManual) {
                targetManual.removeAttribute('hidden');
                $a7dc2840eccdb24c$var$startAnimationOnSteps(targetManual);
            }
        });
    });
};
const $a7dc2840eccdb24c$var$setObserverForManual = (manual)=>{
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                $a7dc2840eccdb24c$var$startAnimationOnSteps(manual);
                observer.unobserve(manual);
            }
        });
    }, {
        threshold: 0.2
    });
    observer.observe(manual);
};
const $a7dc2840eccdb24c$export$ab087199707ec756 = ()=>{
    const orderManuals = document.querySelectorAll('.card-order__product-card-order');
    orderManuals.forEach((manual)=>{
        $a7dc2840eccdb24c$var$setObserverForManual(manual);
    });
    $a7dc2840eccdb24c$var$handleProductSwitching();
};



var $jmFFy = parcelRequire("jmFFy");

var $d8tQ2 = parcelRequire("d8tQ2");
const $b57fb1e860a06a7f$var$init = ()=>{
    (0, $a7dc2840eccdb24c$export$ab087199707ec756)();
    (0, $d8tQ2.default)();
    (0, $jmFFy.initFAQ)();
};
window.onload = $b57fb1e860a06a7f$var$init;

})();
//# sourceMappingURL=script.js.map
